module.exports = __webpack_public_path__ + "media/img/payments/calendar-icon-7944b3b9fff2e1753e7f5cf774c67f92.svg";